import {
  formatUnits,
  parseEther,
  parseUnits,
  readContract,
  writeContractAndWait,
  zeroAddress,
} from "../viem";
import { approveToken, getTokenAllowance } from ".";
import MafiaGICreditAbi from "../../abis/MafiaGICredit.json";
import config from "../../config/config";
import { delay } from "../../utils/utils";
import { isIndexingTxError } from "../parseTxError";

const address = config.giCredit;
const abi = MafiaGICreditAbi;

export const balanceOfGICredit = async (
  user: string,
  signMsg: string,
  signature: string
) => {
  const balance: string = await readContract({
    address,
    abi,
    functionName: "balanceOf",
    args: [user, JSON.stringify(signMsg), signature],
  });

  return Number(formatUnits(balance, 18));
};

export const transferFrom = async (
  sender: string,
  to: string,
  amount: string,
  account: string
) => {
  const transferFrom = await writeContractAndWait({
    address,
    abi,
    functionName: "transferFrom",
    args: [sender, to, amount],
    account,
  });
  return transferFrom;
};

export const approveGICredit = async (
  to: string,
  amount: number,
  account: string
) => {
  const approve = await writeContractAndWait({
    address,
    abi,
    functionName: "approve",
    args: [to, parseUnits(amount.toFixed(18), 18)],
    account,
  });
  return approve;
};

export const getAllowances = async (from: string, to: string) => {
  const allowances: any = await readContract({
    address,
    abi,
    functionName: "allowances",
    args: [from, to],
  });
  return Number(formatUnits(allowances, 18));
};

export const getTotalSupply = async () => {
  const totalSupply = await readContract({
    address,
    abi,
    functionName: "getTotalSupply",
  });
  return totalSupply;
};

export const buyGICredit = async (
  swapTokenId: number,
  tokenAddress: string,
  tokenAmount: number,
  creditAmount: number,
  account: string
) => {
  if (tokenAddress === zeroAddress) {
    const nativeAmount = parseEther(tokenAmount.toFixed(18));
    const buyCredit = await writeContractAndWait({
      address,
      abi,
      functionName: "buyCredit",
      args: [swapTokenId, parseUnits(Number(creditAmount).toFixed(18), 18)],
      account,
      value: nativeAmount,
    });
    return buyCredit;
  } else {
    const tokenAllowance = await getTokenAllowance(
      tokenAddress,
      account,
      config.giCredit
    );

    try {
      if (Number(tokenAllowance) < tokenAmount) {
        await approveToken(tokenAddress, tokenAmount, config.giCredit, account);

        await delay(config.blockTime);
      }
    } catch (error: any) {
      if (isIndexingTxError(error)) {
        await delay(config.blockTime);
      } else {
        throw error;
      }
    }

    const buyCredit = await writeContractAndWait({
      address,
      abi,
      functionName: "buyCredit",
      args: [swapTokenId, parseUnits(Number(creditAmount).toFixed(18), 18)],
      account,
    });
    return buyCredit;
  }
};

export const giCreditPrice = async () => {
  const price: any = await readContract({
    address,
    abi,
    functionName: "price",
  });
  return Number(formatUnits(price, 18));
};

export const unwrapGICreditsItems = async (
  items: number[],
  account: string
) => {
  const unwrap = await writeContractAndWait({
    address,
    abi,
    functionName: "unwrapCreditsItems",
    args: [items],
    account,
  });
  return unwrap;
};
